import React from 'react';
import { Input, FormGroup } from 'reactstrap';

const SearchTemplateId = ({
  idToSearch,
  setIdToSearch,
}) => (
  <FormGroup style={styles.searchContainer}>
    <Input
      style={styles.searchInput}
      id="templateIdSearch"
      name="templateIdSearch"
      placeholder="Search templates by ids (separated by spaces)"
      type="search"
      value={idToSearch}
      onChange={(evt) => setIdToSearch(evt.target.value)}
    />
  </FormGroup>
);

const styles = {
  searchContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15,
  },
  searchInput: {
    width: 400,
  },
};

export default SearchTemplateId;



// WEBPACK FOOTER //
// ./src/components/templates-manager/search-bar/search-templates-id.js